import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import Flickity from "flickity";
import * as dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import css from './style.pcss';
import SupermiroApiRepository from './SupermiroApiRepository.js';
// import 'flickity/dist/flickity.min.css';

import * as localeFR from 'dayjs/locale/fr';
import * as localeEN from 'dayjs/locale/en';
import AddIcon from "./images/ic_add.svg";
import SupermiroLogo from "./images/logo_supermiro.png";
dayjs.extend(customParseFormat);
var RTLSupermiroBox = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSupermiroBox, _LitElement);
  function RTLSupermiroBox() {
    var _this;
    _classCallCheck(this, RTLSupermiroBox);
    _this = _callSuper(this, RTLSupermiroBox);
    _this.events = [];
    _this.language = 'lu';
    _this.site = 'rtl';
    _this.url = "https://www.rtl.lu/kultur/agenda";
    dayjs.locale(localeFR);
    if (window.rtlsites.config.site === "today") {
      dayjs.locale(localeEN);
      _this.url = "https://today.rtl.lu/culture/agenda";
    }
    if (window.rtlsites.config.site === "5minutes") {
      _this.url = "https://5minutes.rtl.lu/culture/agenda";
    }
    return _this;
  }
  _createClass(RTLSupermiroBox, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSupermiroBox.prototype), "connectedCallback", this).call(this);
      this.repo = new SupermiroApiRepository(this.language);
      this._fetchData();
      if (this.language === "en") {
        dayjs.locale(localeEN);
        this.url = "https://today.rtl.lu/culture/agenda";
      }
      if (this.language === "fr") {
        this.url = "https://5minutes.rtl.lu/culture/agenda";
      }
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.repo.getEvents().then(function (resp) {
        _this2.events = resp;
      }).catch(function (e) {
        console.log(e);
      });
    }
  }, {
    key: "renderCard",
    value: function renderCard(elem) {
      return html(_t || (_t = _`<div class="slider__item">
                <div class="supermiro__mirette">
                    <a class="supermiro-box__mirette-link" href="${0}" target="_blank">
                        <div class="supermiro-box__mirette-img" style="background-image: url('${0}'); background-position: center;"></div>

                        <div class="supermiro-box__mirette-text">

                            <div class="supermiro-box__mirette-date">
                                <span class="supermiro-box__mirette-day">${0}</span> <span>${0}</span>

                                ${0}
                            </div>

                            ${0}

                            ${0}

                            <div class="supermiro__mirette-place">${0}</div>
                            <div class="supermiro__mirette-name-event">${0}</div>
                        </div>
                    </a>
                </div>
            </div>`), elem.eventUrl, elem.pictureUrl, dayjs(elem.startDate, "DD-MM-YYYY").format("ddd"), dayjs(elem.startDate, "DD-MM-YYYY").format("D MMM."), elem.startDate !== elem.endDate ? html(_t2 || (_t2 = _`<span class="supermiro-box__mirette-dash"></span>
                                        <span class="supermiro-box__mirette-day">${0}</span> <span>${0}</span>`), dayjs(elem.endDate, "DD-MM-YYYY").format("ddd"), dayjs(elem.endDate, "DD-MM-YYYY").format("D MMM.")) : null, elem.startTime ? html(_t3 || (_t3 = _`<div class="supermiro-box__mirette-start-time">${0}</div>`), elem.startTime.slice(0, -3)) : null, !elem.startTime ? html(_t4 || (_t4 = _`<div class="supermiro-box__mirette-start-time">All day</div>`)) : null, elem.placeName, elem.title.replace(/(.{50})..+/, "$1…"));
    }
  }, {
    key: "renderShowMoreButton",
    value: function renderShowMoreButton() {
      return html(_t5 || (_t5 = _`<a class="supermiro-box__more" href="${0}">
            <div class="supermiro-box__more-content">
                <div class="supermiro-box__more-title">Show the full agenda</div>
                <img class="supermiro-box__more-image" src="${0}" />
            </div>
        </a>`), this.url, AddIcon);
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (this.hideHeader) return null;
      return html(_t6 || (_t6 = _`<div class="supermiro-box__header-container">
            <div class="supermiro-box__header-content">
                <h1 class="supermiro-box__header-title">Agenda</h1>
                <div class="supermiro-box__header-brand"> <span>by</span> <a href="https://www.supermiro.lu/" target="_blank"> <img class="supermiro-box__brand-img" src="${0}"></img> </a></div>
            </div>
            ${0}
        </div>`), SupermiroLogo, this.renderShowMoreButton());
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.events == undefined || this.events.length == 0) return;
      this.updateComplete.then(function () {
        if (!_this3.flickity) {
          var slider = _this3.querySelector('.slider');
          _this3.flickity = new Flickity(slider, {
            groupCells: true,
            wrapAround: true,
            cellAlign: 'left',
            contain: true
          });
        }
      });
      var events = this.events;
      var className = "supermiro-box__container";
      if (this.hideHeader) {
        className = "supermiro-box__container--no-border";
      }
      return html(_t7 || (_t7 = _`
            <style>${0}</style>
            <div class="${0}">
                ${0}
                <div class="slider slider--supermiro slider--supermiro-box">
                        ${0}
                </div>
            </div>
        `), css, className, this.renderHeader(), events.map(function (event) {
        return _this3.renderCard(event);
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        language: {
          type: String
        },
        events: {
          type: Array
        },
        hideHeader: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLSupermiroBox;
}(LitElement);
export { RTLSupermiroBox as default };
window.customElements.define('rtl-supermiro-box', RTLSupermiroBox);